import React from "react";
import { isIOS, isMacOs, isMobile } from "react-device-detect";
import { getMapsLink } from "@default/lib/get-maps-link";
import AccessibilityIcons from "@default/general-components/accessibility-icons";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";

const TeaserTags = (props) => {
  return (
    <div className="tag-wrapper">
      {props.properties &&
        props.properties.map((property) => (
          <div className="tag body-m" key={property.id}>
            {property.name}
          </div>
        ))}
      {props.capacity && props.capacity > 0 && props.capacity !== "0" && (
        <div className="tag body-m">{props.capacity}P</div>
      )}
      <AccessibilityIcons content={props.accessibility} />
    </div>
  );
};

TeaserTags.propTypes = {
  properties: PropTypes.array,
  capacity: PropTypes.number,
};

const TeaserVenueContent = ({ item, expanded = true }) => {
  const currentLanguage = useSelector((state) => state.i18n.currentLanguage);

  const openLocationLink = ({
    name,
    address,
    geo,
    parentLocation,
    fallback,
  }) => {
    //@todo: Implement function to let the user set a forced gmaps link
    /*if (!!fallback) {
      return window.open(fallback, "_blank");
    }*/

    if (isIOS || isMacOs) {
      return window.open(
        getMapsLink(name, address, geo, { platform: "apple" }, parentLocation),
        "_blank"
      );
    }

    if (isMobile) {
      return window.open(
        getMapsLink(
          name,
          address,
          geo,
          { platform: "android" },
          parentLocation
        ),
        "_blank"
      );
    }
    return window.open(
      getMapsLink(name, address, geo, {}, parentLocation),
      "_blank"
    );
  };

  const description =
    currentLanguage === "de"
      ? item.fieldExternalDescriptionDe
      : item.fieldExternalDescriptionEn;

  return (
    <>
      {(!!item.fieldLocationProperties ||
        !!item.fieldCapacity ||
        !!item.fieldAccessibility) && (
        <TeaserTags
          properties={item.fieldLocationProperties}
          capacity={!!item.fieldCapacity && item.fieldCapacity}
          accessibility={!!item.fieldAccesibility && item.fieldAccesibility}
        />
      )}
      {description && (
        <div
          className="text description"
          dangerouslySetInnerHTML={{ __html: description }}
        />
      )}
      {item.fieldAddress && (
        <div className="address-wrapper">
          <address>
            {item.fieldAddress.addressLine1 && (
              <span className="street">{item.fieldAddress.addressLine1}</span>
            )}
            {item.fieldAddress.postalCode && item.fieldAddress.locality && (
              <div className="city-wrapper">
                {item.fieldAddress.postalCode && (
                  <span className="postal-code">
                    {item.fieldAddress.postalCode}
                  </span>
                )}
                {item.fieldAddress.locality && (
                  <span className="locality">{item.fieldAddress.locality}</span>
                )}
              </div>
            )}
          </address>
          <a
            className="maps-link action-element"
            tabIndex={expanded ? "0" : "-1"}
            onClick={() =>
              openLocationLink({
                name: item.label,
                address: item.fieldAddress,
                geo: {
                  lat: item.fieldGeolocation?.lat,
                  lng: item.fieldGeolocation?.lng,
                },
                parentLocation: item.fieldParentLocation,
              })
            }
          >
            Find me on Maps
          </a>
        </div>
      )}
    </>
  );
};

export default TeaserVenueContent;
